export default {
  data() {
    return {
      enterpriseAnnualPrice: "$699",
      enterpriseMonthlyPrice: '$69',
      businessAnnualPrice: '$360',
      businessMonthlyPrice: '$38',
      proAnnualPrice: '$108',
      proMonthlyPrice: '$18',
      currency: '$',
    }
  },
  computed: {
    enterpriseAnnualPriceMonthly() {
      const toNumber = function (currency) {
        return Number(currency.replace(/[^0-9\.-]+/g, ''))
      }

      const monthlyPriceIfPaidYearly = toNumber(this.enterpriseAnnualPrice)
      return this.currency + Math.round(monthlyPriceIfPaidYearly / 12)
    },
    businessAnnualPriceMonthly() {
      const toNumber = function (currency) {
        return Number(currency.replace(/[^0-9\.-]+/g, ''))
      }

      const monthlyPriceIfPaidYearly = toNumber(this.businessAnnualPrice)
      return this.currency + Math.round(monthlyPriceIfPaidYearly / 12)
    },
    proAnnualPriceMonthly() {
      const toNumber = function (currency) {
        return Number(currency.replace(/[^0-9\.-]+/g, ''))
      }

      const monthlyPriceIfPaidYearly = toNumber(this.proAnnualPrice)
      return this.currency + Math.round(monthlyPriceIfPaidYearly / 12)
    },
    proAnnualPriceMonthlyNumber() {
      const toNumber = function (currency) {
        return Number(currency.replace(/[^0-9\.-]+/g, ''))
      }

      return Math.round(toNumber(this.proAnnualPriceMonthly))
    },
    businessAnnualPriceMonthlyNumber() {
      const toNumber = function (currency) {
        return Number(currency.replace(/[^0-9\.-]+/g, ''))
      }

      return Math.round(toNumber(this.businessAnnualPriceMonthly))
    },
    enterpriseAnnualPriceMonthlyNumber() {
      const toNumber = function (currency) {
        return Number(currency.replace(/[^0-9\.-]+/g, ''))
      }

      return Math.round(toNumber(this.enterpriseAnnualPriceMonthly))
    },
    proAnnualSavings() {
      const toNumber = function (currency) {
        return Number(currency.replace(/[^0-9\.-]+/g, ''))
      }

      return Math.round((1 - toNumber(this.proAnnualPrice) / (toNumber(this.proMonthlyPrice) * 12)) * 100)
    },
    businessAnnualSavings() {
      const toNumber = function (currency) {
        return Number(currency.replace(/[^0-9\.-]+/g, ''))
      }

      return Math.round((1 - toNumber(this.businessAnnualPrice) / (toNumber(this.businessMonthlyPrice) * 12)) * 100)
    },
    enterpriseAnnualSavings() {
      const toNumber = function (currency) {
        return Number(currency.replace(/[^0-9\.-]+/g, ''))
      }

      return Math.round((1 - toNumber(this.enterpriseAnnualPrice) / (toNumber(this.enterpriseMonthlyPrice) * 12)) * 100)
    },
  },
}
